import { TimelineRange } from './types';

export function clampTime(time: number, duration: number): number {
  return Math.max(0, Math.min(time, Math.max(0, duration)));
}

export function frameToTime(frame: number, fps: number): number {
  return Math.max(0, frame) / Math.max(1, fps);
}

export function timeToFrame(time: number, fps: number): number {
  return Math.round(Math.max(0, time) * Math.max(1, fps));
}

export function normalizeRange(
  startTime: number,
  endTime: number,
  duration: number,
): TimelineRange {
  const start = clampTime(startTime, duration);
  const end = clampTime(endTime, duration);

  if (end < start) {
    return {
      startTime: end,
      endTime: end,
    };
  }

  return {
    startTime: start,
    endTime: end,
  };
}
